import { defineStore } from 'pinia'
import { useFetch } from '@/modules/core/composables/useFetch'
import { Connection } from '../types'
import { computed, ref } from 'vue'
import { useRoute } from 'vue-router'

export const useConnectionStore = defineStore('connecting/connectionStore', () => {
  const route = useRoute()
  const baseUrl = `/v4/${route.params.slug}/connecting/connections`
  const items = ref<Connection[]>([])
  const connections = computed(() => items.value)

  // queries
  const fetchConnections = async (payload: { status: string; group_id?: string; individual_id?: string }) => {
    const params = new URLSearchParams()
    params.set('status', payload.status)
    if (payload.group_id) params.set('group_id', payload.group_id)
    if (payload.individual_id) params.set('individual_id', payload.individual_id)

    const queryParams = params.toString() ? `?${params}` : ''

    const data = await useFetch(`${baseUrl}${queryParams}`).get<Connection[]>()
    items.value = [...data]
  }

  // commands
  const acceptInvite = async (connectionId: string) => {
    await useFetch(`${baseUrl}/${connectionId}/accept-invite`).post()
  }

  const rejectInvite = async (connectionId: string) => {
    await useFetch(`${baseUrl}/${connectionId}/reject-invite`).post()
  }

  const inviteCandidate = async (connectionId: string) => {
    await useFetch(`${baseUrl}/${connectionId}/invite`).post()
  }

  const rejectCandidate = async (connectionId: string) => {
    await useFetch(`${baseUrl}/${connectionId}/reject`).post()
  }

  const withdrawInvite = async (connectionId: string) => {
    await useFetch(`${baseUrl}/${connectionId}/withdraw-invite`).post()
  }

  const restoreCandidate = async (connectionId: string) => {
    await useFetch(`${baseUrl}/${connectionId}/restore`).post()
  }

  const fetchAgreement = async (connectionId: string) => {
    return await useFetch(`${baseUrl}/${connectionId}/agreement`).get<{
      agreement_id: number
      file_url: string
      file_name: string
    }>()
  }

  const acceptAgreement = async (connectionId: string) => {
    await useFetch(`${baseUrl}/${connectionId}/accept-agreement`).post()
  }

  // helpers
  const getConnection = (connectionId: string) => {
    return items.value.find((connection) => connection.id.toString() === connectionId.toString())
  }

  return {
    connections,
    fetchConnections,

    acceptInvite,
    inviteCandidate,
    rejectInvite,
    rejectCandidate,
    restoreCandidate,
    withdrawInvite,

    fetchAgreement,
    acceptAgreement,

    getConnection,
  }
})
